import { curryN } from "ramda";
export default curryN(2, (f, xs) => {
    const init = [];
    return xs.reduce((r, x, i) => (r.length ? r.concat([f(x, i), x]) : r.concat(x)), init);
});
//# sourceMappingURL=intersperseWith.mjs.map